require('vanilla-cookieconsent')

var cookieconsent = window.initCookieConsent()

cookieconsent.run({
  autorun: true,
  delay: 0,
  current_lang: 'de',
  auto_language: false,
  autoclear_cookies: true,
  cookie_expiration: 365,
  force_consent: false,

  onAccept: function (cookie) {
    if (cookieconsent.allowedCategory('analytics')) {
      (function (w, d, t, u, n, a, m) {
        w['MauticTrackingObject'] = n
        w[n] = w[n] || function () {(w[n].q = w[n].q || []).push(arguments)}, a = d.createElement(t),
          m = d.getElementsByTagName(t)[0]
        a.async = 1
        a.src = u
        m.parentNode.insertBefore(a, m)
      })(window, document, 'script', 'https://m.roemmich.eu/mtc.js', 'mt')

      mt('send', 'pageview')
    }
  },

  languages: {
    'de': {
      consent_modal: {
        title: 'Wir verwenden Cookies',
        description: 'Wir nutzen Cookies auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern. <button type="button" data-cc="c-settings" class="cc-link">Einstellungen</button>',
        primary_btn: {
          text: 'Alle akzeptieren',
          role: 'accept_all',
        },
        secondary_btn: {
          text: 'Abbrechen',
          role: 'accept_necessary',
        },
      },
      settings_modal: {
        title: '<div>Cookie Einstellungen</div>',
        save_settings_btn: 'Einstellungen akzeptieren',
        accept_all_btn: 'Alle akzeptieren',
        close_btn_label: 'Schließen',
        cookie_table_headers: [
          { col1: 'Name' },
          { col2: 'Anbieter' },
          { col3: 'Cookie Laufzeit' },
          { col4: 'Beschreibung' },
          { col5: 'Typ' },
        ],
        blocks: [
          {
            title: 'Datenschutzeinstellungen',
            description: 'Hier finden Sie eine Übersicht über alle verwendeten Cookies. Sie können Ihre Zustimmung zu ganzen Kategorien geben oder sich weitere Informationen anzeigen lassen und so nur bestimmte Cookies auswählen.',
          }, {
            title: 'Essenziell',
            description: 'Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.',
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true,
            },
          }, {
            title: 'Präferenzen',
            description: 'Präferenz-Cookies ermöglichen einer Webseite sich an Informationen zu erinnern, die die Art beeinflussen, wie sich eine Webseite verhält oder aussieht, wie z. B. Ihre bevorzugte Sprache oder die Region in der Sie sich befinden.',
            toggle: {
              value: 'preferences',	//there are no default categories => you specify them
              enabled: false,
              readonly: false,
            },
          }, {
            title: 'Statistiken',
            description: 'Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.',
            toggle: {
              value: 'analytics',
              enabled: false,
              readonly: false,
            },
            cookie_table: [
              {
                col1: '_ga',
                col2: 'google.com',
                col3: '2 Jahre',
                col4: 'Cookie von Google für Website-Analysen. Erzeugt statistische Daten darüber, wie der Besucher die Website nutzt.',
                col5: 'Permanenter Cookie',
              },
              {
                col1: '_gat',
                col2: 'google.com',
                col3: '1 Minute',
                col4: 'Wird von Google Analytics verwendet, um die Anforderungsrate einzuschränken.',
                col5: 'Temporärer Cookie',
              },
              {
                col1: '_gid',
                col2: 'google.com',
                col3: '1 Tag',
                col4: 'Registriert eine eindeutige ID, die verwendet wird, um statistische Daten dazu, wie der Besucher die Website nutzt, zu generieren.',
                col5: 'Temporärer Cookie',
              },
              {
                col1: '_fbp',
                col2: 'facebook.com',
                col3: '3 Monate',
                col4: 'Registriert eine eindeutige ID, die verwendet wird, um statistische Daten dazu, wie der Besucher die Website nutzt, zu generieren.',
                col5: 'Permanenter Cookie',
              },
            ],
          },
        ],
      },
    },
  },
})
